import { FC, useMemo } from 'react';
import { Grid, Stack, Typography } from '@mui/material';
import { format } from 'date-fns';

import { useDictionary } from '@cvt/hooks/useDictionary';
import { BoxWell } from '@shared/components/BoxWell';

import { useUserPreferenceHistory } from '@modules/Users/hooks/useUserPreferenceHistory';


interface Props {
  createdLabel: string;
}

export const PreferenceVersionSummary: FC<Props> = ({ createdLabel }) => {

  const dictionary = useDictionary();

  const { preferenceHistory, count } = useUserPreferenceHistory({});

  const latestHistoryChange = useMemo(() => {
    return preferenceHistory[0] || {};
  }, [preferenceHistory]);

  return (
    <BoxWell
      sx={{
        p: { xs: 0, sm: 5 },
        borderColor: { xs: 'transparent', sm: 'divider' },
      }}
    >
      <Stack gap={2}>
        <Typography variant="h5" component="h2" fontWeight={600} fontSize={18}>
          {dictionary.preferences.versionSummary.title}
        </Typography>
        <Typography variant="body2" component="h2" color="text.secondary" mt={1}>
          {dictionary.preferences.versionSummary.subtitle}
        </Typography>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm:4 }}>
            <BoxWell sx={{ height: '100%' }}>
              <Stack gap={1} justifyContent="space-between" height="100%">
                <Typography variant="body2"  color="text.secondary" fontWeight={600}>
                  {dictionary.preferences.versionSummary.version}
                </Typography>
                <Typography variant="body2" color="primary.main" fontWeight={600} fontSize={18} mt={0.5}>
                  V{count}
                </Typography>
                <Typography variant="body1" fontSize={12}>
                  {dictionary.preferences.versionSummary.lastUpdated} {format(latestHistoryChange.historyDate, 'MMMM dd, yyyy')}
                </Typography>
              </Stack>
            </BoxWell>
          </Grid>

          <Grid size={{ xs: 12, sm:4 }}>
            <BoxWell sx={{ height: '100%' }}>
              <Stack gap={1} justifyContent="space-between" height="100%">
                <Typography variant="body2"  color="text.secondary" fontWeight={600}>
                  {dictionary.preferences.versionSummary.communicationScore}
                </Typography>
                <Typography variant="body2" color="primary.main" fontWeight={600} fontSize={18} mt={0.5}>
                  100/100
                </Typography>
                <Typography variant="body1" fontSize={12}>
                  {dictionary.preferences.versionSummary.basedOnStoryAssessments}
                </Typography>
              </Stack>
            </BoxWell>
          </Grid>

          <Grid size={{ xs: 12, sm:4 }}>
            <BoxWell sx={{ height: '100%' }}>
              <Stack gap={1} justifyContent="space-between" height="100%">
                <Typography variant="body2"  color="text.secondary" fontWeight={600}>
                  {dictionary.preferences.versionSummary.created}
                </Typography>
                <Typography variant="body2" fontWeight={500}>
                  {format(latestHistoryChange.created, 'MMMM dd, yyyy')}
                </Typography>
                <Typography variant="body1" fontSize={12}>
                  {createdLabel}
                </Typography>
              </Stack>
            </BoxWell>
          </Grid>
        </Grid>
      </Stack>
    </BoxWell>
  );
};